/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * If the click edit field has an action
 */
export enum DocumentFormAction {
    OPEN_LINK_MODAL = 'openLinkModal',
    VIEW_ALL_RELATED_PEOPLE = 'viewAllRelatedPeople',
}
